// ⚠️ 자동 생성 파일 — 직접 수정 금지. 정본은 dentcluster-agent/shared/clinic-stage.js
//    수정 절차: 정본 수정 → node scripts/sync-shared.js (release-all.sh가 불일치 시 빌드 중단)
// [공통 정본] 의뢰서 「공정」 표시 단계 — 공정 3단계 + 환자 2단계
//   정본은 이 파일(dentcluster-agent/shared/). 사본(node scripts/sync-shared.js 가 생성 — 직접 수정 금지):
//     functions/lib/shared/clinic-stage.js (CJS 그대로) · 웹 src/utils/shared/clinic-stage.js (ESM, 2026-10-12 web:true 전환)
//   앱(Flutter) 사본 lib/features/clinic/clinic_stage.dart 는 수동 이식 — 판정표는 docs/계약_공정3단계_2026-10-12.md §2 와 같아야 한다.
//
// ── 공정 3단계 (2026-10-12 대표 확정 — 덴클 앱 1.3.0 계획 §10 "권고대로". 웹·치과·앱 공통) ──────────────────────
//   「의뢰서 확인 · 디자인 완료 · 포장 완료」 3개만 보여준다. 확인 전(접수)은 단계 없음 = 칩 없음(key null).
//   구 4단계(접수/확인/디자인완료/밀링완료, 2026-09-29)를 대체한다. 밀링 신호(에이전트 .xmll → processStage milling,
//   checks.mill)·QR 체크(mill·implantMill 등)는 데이터 그대로 두고 표시만 「디자인 완료」로 묶는다.
//   저장값 모델(processStage 6값 received/scanning/designing/milling/shipping/done · designDone · checks{...} · status)은 불변 —
//   이 파일은 읽기 전용 표시 계층이다. 에이전트·rules·CF 쓰기 경로를 바꾸지 않는다.
//
//   판정 순서 (stage3Of — 위가 우선):
//     ① 취소·거절(status cancelled/canceled/rejected)        → key null (cancelled:true, 칩 없음)
//     ② 포장 완료 packed    = checks.packing 완료(사람의 QR·[포장완료] 체크 — auto_due 여부 무관)
//                           또는 receivedAt 있음(치과 수령 기록 — 포장이 끝난 뒤에만 생김)
//                           또는 auto_due 가 아닌 종결(processStage shipping/done 또는 status completed — 사람이 배송·완료 처리한 구 문서)
//                           또는 stageHistory 에 auto_due 가 아닌 shipping 기록(구 포장완료 칸 — 서버 백필로 stageSource 가 auto_due 가 된 문서)
//     ③ auto_due(납기 자정 서버 자동 완료, 포장 체크 없음) → 남은 신호로 판정(아래 ④⑤ — processStage 'done' 은 신호가 아님)
//                           + autoDue:true. 치과 문구는 '도착 예정일 지남'(도착 단정 금지 2026-09-29) — clinicStageOf 가 처리
//     ④ 디자인 완료 designDone = designDone===true 또는 processStage milling 또는 checks.mill/implantMill 완료 또는 millChecked===true
//                           (auto_due 문서는 stageHistory 의 milling 기록도 인정)
//     ⑤ 의뢰서 확인 confirmed = processStage received/scanning/designing 또는 checks.scan/modelPrint/jigPrint 완료
//                           또는 printChecked===true 또는 printedAt/downloadedPdfAt/cadSentAt 있음
//                           (auto_due 문서는 stageHistory 의 received/scanning/designing 기록도 인정)
//     ⑥ 그 외               → key null (접수 — 칩 없음). readByReceiver/readAt(목록 배지 읽음)은 확인으로 치지 않는다.
//
// ── 환자 2단계 (기획서_치과환자관리 §5-2 (a) — 2026-10-12 3단계 개편과 무관, 판정 결과 불변) ──────────────────
//   received(접수됨) → arrived(치과 도착). 포장 체크(checks.packing.done 또는 shipping/done 단계)가 있으면 packed 칩.
//   stageSource 'auto_due' 건은 '완성' 칩을 붙이지 않고(isPackedOrder=false — 단, 기공소가 포장 체크를 실제로 한
//   checks.packing.done 은 사람의 행위라 인정) 라벨만 PATIENT_AUTO_DUE_LABEL 로 바꾼다(법무 확정 문구).
//   환자 화면에는 processStage 원값·designDone·밀링 등 세부 신호를 절대 내보내지 않는다(보안검토 P0-2 화이트리스트).
//
// ── stageColOf (구 4열 키 intake/confirm/design/mill) ──
//   표시용이 아니다. 서버 dailyStallDigest(멈춤 알림)·웹 caseChecks.getStallInfo 의 체류일 칸 계산 전용 — 결과값 불변.
//   칸 키·표식 키(stallNotifiedAt.{칸})는 그대로 두고, 칸 이름·기준 일수는 STALL_STAGES(정본, 3단계 이름)를 쓴다
//   (2026-10-12 대표 "권고대로" — 계약 문서 §7-1). mill(밀링) 칸은 3단계에서 「디자인 완료」로 묶여 보이므로 같은 이름·같은 일수.

// ── 공정 3단계 ──────────────────────────────────────────────────────────────
const STAGE3_KEYS = ['confirmed', 'designDone', 'packed'];
const STAGE3_LABELS = { confirmed: '의뢰서 확인', designDone: '디자인 완료', packed: '포장 완료' };
// 하위 호환 이름 — 2026-10-12부터 3단계 값(구 4단계 값 아님)
const CLINIC_STEPS = STAGE3_KEYS.map((k) => STAGE3_LABELS[k]);
const STEP_KEYS = STAGE3_KEYS;
/** 치과 화면 보조 문구 — 납기 자정 자동 완료(auto_due) + 포장 체크 없음. 도착을 단정하지 않는다(2026-09-29 법무) */
const AUTO_DUE_NOTICE = '도착 예정일 지남';
const AUTO_DUE_DETAIL = '자동 처리 — 도착 여부는 기공소와 확인';

const CANCELLED_STATUSES = ['cancelled', 'canceled', 'rejected'];
const CONFIRM_STAGES = ['received', 'scanning', 'designing'];

/** checks 맵의 항목 완료 여부 — {done:true} 객체 또는 true(구 형식). 별칭 키(mill→milling, packing→packed)도 읽는다(웹 caseChecks.readCheck 와 같음) */
function checkDone(order, key) {
    const checks = order && order.checks && typeof order.checks === 'object' ? order.checks : null;
    if (!checks) return false;
    const ALT = { mill: 'milling', packing: 'packed' };
    let raw = checks[key];
    if (raw === undefined && ALT[key]) raw = checks[ALT[key]];
    if (raw === true) return true;
    return !!(raw && typeof raw === 'object' && raw.done === true);
}

function historyHas(order, stages, { excludeAutoDue = false } = {}) {
    const hist = order && Array.isArray(order.stageHistory) ? order.stageHistory : [];
    return hist.some((h) => h && stages.includes(h.stage) && !(excludeAutoDue && h.source === 'auto_due'));
}

/** 납기 자정 자동 완료 건(서버 scheduledAutoDueDone) — 도착·완성을 단정하지 않는다 */
function isAutoDueOrder(order) {
    return !!order && order.stageSource === 'auto_due' && (order.processStage === 'done' || order.status === 'completed');
}

/** 종결 단계 여부 — shipping/done 또는 status completed (auto_due 포함 — 구별은 isAutoDueOrder) */
function isClosedStage(order) {
    if (!order) return false;
    const s = order.processStage;
    return s === 'shipping' || s === 'done' || order.status === 'completed';
}

/**
 * 공정 3단계 판정 — 웹·치과·앱 공통 정본 (판정 순서는 파일 머리 주석, 판정표는 계약 문서 §2).
 * @param {object} order workOrders 또는 parsedCases 문서(평범한 객체)
 * @returns {{ key: null|'confirmed'|'designDone'|'packed', label: string|null, step: 0|1|2|3,
 *             autoDue: boolean, received: boolean, cancelled: boolean }}
 *   key null = 칩 없음(접수 또는 취소). step = 채워진 점 수(0~3). autoDue = 납기 자정 자동 완료 + 포장 체크 없음.
 */
function stage3Of(order) {
    const r = (key, extra) => ({
        key,
        label: key ? STAGE3_LABELS[key] : null,
        step: key ? STAGE3_KEYS.indexOf(key) + 1 : 0,
        autoDue: false,
        received: false,
        cancelled: false,
        ...(extra || {}),
    });
    if (!order) return r(null);
    if (CANCELLED_STATUSES.includes(order.status || '')) return r(null, { cancelled: true });

    const autoDue = isAutoDueOrder(order);
    const received = !!order.receivedAt;
    // ② 포장 완료
    if (checkDone(order, 'packing')) return r('packed', { received });
    if (received) return r('packed', { received: true });
    if (!autoDue && isClosedStage(order)) return r('packed');
    if (historyHas(order, ['shipping'], { excludeAutoDue: true })) return r('packed');

    // ③ auto_due(포장 체크 없음) — 'done' 은 신호가 아니므로 이력·체크·designDone 으로 남은 단계를 판정
    const stage = autoDue ? null : order.processStage;
    const extra = autoDue ? { autoDue: true } : null;

    // ④ 디자인 완료
    if (order.designDone === true || stage === 'milling' || checkDone(order, 'mill') || checkDone(order, 'implantMill') ||
        order.millChecked === true || (autoDue && historyHas(order, ['milling']))) {
        return r('designDone', extra);
    }
    // ⑤ 의뢰서 확인
    if (CONFIRM_STAGES.includes(stage) || checkDone(order, 'scan') || checkDone(order, 'modelPrint') || checkDone(order, 'jigPrint') ||
        order.printChecked === true || !!order.printedAt || !!order.downloadedPdfAt || !!order.cadSentAt ||
        (autoDue && historyHas(order, CONFIRM_STAGES))) {
        return r('confirmed', extra);
    }
    // ⑥ 접수 — 칩 없음
    return r(null, extra);
}

/** 3단계 색 — 포장 완료 진회색 / 디자인 완료 초록 / 의뢰서 확인 남색 */
const STAGE3_COLOR = { confirmed: '#4f46e5', designDone: '#0b6e5d', packed: '#64748b' };

/**
 * 포장완료 쓰기 패치 — 웹 caseChecks.buildCheckPatch('packing', true, order) 와 같은 값(계약 문서 §4).
 * 앱 [포장완료] 버튼은 이 값을 그대로 workOrders 에 update 한다. status·completedAt 은 쓰지 않는다(웹과 같음).
 * @param {object} order 현재 문서(processStage 를 그대로 동봉 — 웹과 같은 형태. 없으면 생략)
 * @param {string} nowIso 클라이언트 시각 ISO 문자열(new Date().toISOString())
 * @returns {object} update 객체(점 표기 키 'checks.packing')
 */
function buildPackingPatch(order, nowIso) {
    const patch = {
        'checks.packing': { done: true, at: String(nowIso), by: 'user', revertedFromAuto: false },
    };
    const isParsed = !!order && (order._isParsed === true || order._col === 'parsedCases');
    if (!isParsed && order && order.processStage) patch.processStage = order.processStage;
    return patch;
}

/** 멈춤 판정 칸(stageColOf 키 + 'intake') → 알림·화면용 이름(3단계 이름). 접수(intake)는 단계가 아니므로 '의뢰서 확인 전' */
const STALL_COL_LABELS = { intake: '의뢰서 확인 전', confirm: STAGE3_LABELS.confirmed, design: STAGE3_LABELS.designDone, mill: STAGE3_LABELS.designDone };
/**
 * 멈춤 판정 기준표 — 서버 dailyStallDigest·웹 caseChecks.getStallInfo 공용 정본(2026-10-12, 계약 §7-1. 이전엔 두 곳에 복제).
 *   칸 키 = stageColOf 4열 키(+intake) — stallNotifiedAt.{칸} 표식 키와 같아 바꾸지 않는다. 포장 완료(packed)·종결은 칸 없음 = 멈춤 제외.
 *   일수: 의뢰서 확인 전 2 · 의뢰서 확인 3 · 디자인 완료 3. mill(밀링) 칸은 「디자인 완료」로 보이므로 같은 3일
 *   (구 '밀링완료' 2일에서 변경 — 같은 이름에 기준이 둘이면 공개 기준표가 모순된다). 일수는 대표 확인 예정(2026-09-29부터 동일).
 */
const STALL_STAGES = [
    { stage: 'intake', label: STALL_COL_LABELS.intake, days: 2 },
    { stage: 'confirm', label: STALL_COL_LABELS.confirm, days: 3 },
    { stage: 'design', label: STALL_COL_LABELS.design, days: 3 },
    { stage: 'mill', label: STALL_COL_LABELS.mill, days: 3 },
];
/** 내원일까지 여유가 이 값(일) 미만이면 모든 칸 임계를 1일로 (대표 확정 D6) */
const STALL_VISIT_SLACK_DAYS = 3;

/**
 * 저장 단계(processStage·designDone) → 구 4열 키. ⚠️ 표시용 아님(파일 머리 주석) — 멈춤 판정 체류 칸 계산 전용.
 * @returns {'confirm'|'design'|'mill'|null}
 */
function stageColOf(stage, designDone) {
    if (stage === 'milling') return 'mill';
    if (stage === 'designing') return designDone === true ? 'design' : 'confirm';
    if (stage === 'scanning' || stage === 'received') return 'confirm';
    return null;
}

/**
 * 치과 화면 표시(구 API 모양 유지 — 웹 OrderList·ProcessDayModal 이 쓰던 형태). 2026-10-12부터 3단계.
 * @returns {{ label, step, pct, tone:'done'|'active'|'wait', bucket:string|null, detail:string|null, key:string|null, autoDue:boolean }}
 *   label '' = 칩 없음(접수·취소). bucket = STAGE3_KEYS 중 하나 또는 null. step 0~3.
 *   auto_due(포장 체크 없음) = label '도착 예정일 지남'(도착 단정 금지), bucket 은 남은 단계.
 */
function clinicStageOf(order, scan) {
    const s = stage3Of(order);
    const out = (label, pct, tone, detail = null) => ({ label, step: s.step, pct, tone, bucket: s.key, detail, key: s.key, autoDue: s.autoDue });
    if (!order || s.cancelled) return out('', 0, 'wait');
    if (s.autoDue) return out(AUTO_DUE_NOTICE, 90, 'wait', AUTO_DUE_DETAIL);
    if (s.key === 'packed') return out(STAGE3_LABELS.packed, 100, 'done', '기공소가 포장을 마침');
    if (s.key === 'designDone') return out(STAGE3_LABELS.designDone, 66, 'active');
    if (s.key === 'confirmed') return out(STAGE3_LABELS.confirmed, 33, 'active');
    // 접수(칩 없음) — 치과 스캔 전송 상태는 보조 문구(detail)로만
    if (order.scanId) {
        if (scan === undefined) return out('', 0, 'wait', '스캔 확인 중…');
        const st = scan ? scan.status : undefined;
        if (st === 'unknown') return out('', 0, 'wait', '스캔 상태 확인 불가');
        if ((scan && scan.transfer && scan.transfer.deliveredAt) || st === 'delivered') return out('', 0, 'wait', '스캔 도착(기공소)');
        if (st === 'ready') return out('', 0, 'wait', '스캔 전송됨');
        if (st === 'detected' || st === 'uploading' || (scan && scan.uploadRequested)) return out('', 0, 'wait', '스캔 감지 · 전송 중');
        if (scan === null) return out('', 0, 'wait', '스캔 연결 끊김');
        return out('', 0, 'wait', '스캔 감지');
    }
    return out('', 0, 'wait');
}

/** 색 — done 진회색(포장 완료) / active 남색 / wait 회색 */
function stageColor(tone) {
    return tone === 'done' ? '#64748b' : tone === 'active' ? '#4f46e5' : '#94a3b8';
}

// ── 환자 2단계 (판정 결과 불변) ────────────────────────────────────────────────
const PATIENT_STAGE_KEYS = ['received', 'arrived'];
const PATIENT_STAGE_LABELS = { received: '접수됨', arrived: '치과 도착' };
const PATIENT_PACKED_LABEL = '완성';
/** 환자앱 카드 문구 — 납기 자정 자동 완료(auto_due) 건, receivedAt 없음 (법무 확정 2026-09-29) */
const PATIENT_AUTO_DUE_LABEL = '도착 예정일 지남 — 도착 여부는 치과에 확인해 주세요';

/** 포장 체크(QR 공정 체크) 또는 shipping/done·completed 여부. auto_due 자동 완료는 포장으로 치지 않는다(QR 포장 체크는 사람 행위라 인정).
 *  ※ 환자 2단계 전용 — 공정 3단계의 '포장 완료'는 stage3Of(receivedAt·구 shipping 이력까지 인정)를 쓴다. */
function isPackedOrder(order) {
    if (!order) return false;
    if (order.checks && order.checks.packing && order.checks.packing.done === true) return true;
    if (isAutoDueOrder(order)) return false;
    return isClosedStage(order);
}

/**
 * 환자에게 보여줄 2단계 판정 — 화이트리스트 결과만 반환한다(원값 없음).
 * @param {object} order workOrders 문서(또는 그 부분집합: receivedAt·processStage·designDone·status·checks)
 * @returns {{ key:'received'|'arrived', label:string, step:1|2, packed:boolean, packedLabel:string|null }}
 */
function patientStageOf(order) {
    const packed = isPackedOrder(order);
    if (order && order.receivedAt) {
        return { key: 'arrived', label: PATIENT_STAGE_LABELS.arrived, step: 2, packed, packedLabel: packed ? PATIENT_PACKED_LABEL : null };
    }
    // 자동 완료(auto_due) — 키는 'received' 그대로(화이트리스트 불변), 라벨만 예정일 안내로 (기존 라벨 필드에 실린다)
    if (isAutoDueOrder(order)) {
        return { key: 'received', label: PATIENT_AUTO_DUE_LABEL, step: 1, packed, packedLabel: packed ? PATIENT_PACKED_LABEL : null };
    }
    return { key: 'received', label: PATIENT_STAGE_LABELS.received, step: 1, packed, packedLabel: packed ? PATIENT_PACKED_LABEL : null };
}

export { STAGE3_KEYS, STAGE3_LABELS, STAGE3_COLOR, AUTO_DUE_NOTICE, AUTO_DUE_DETAIL, CLINIC_STEPS, STEP_KEYS, stage3Of, buildPackingPatch, stageColOf, STALL_COL_LABELS, STALL_STAGES, STALL_VISIT_SLACK_DAYS, isClosedStage, clinicStageOf, stageColor, PATIENT_STAGE_KEYS, PATIENT_STAGE_LABELS, PATIENT_PACKED_LABEL, PATIENT_AUTO_DUE_LABEL, isAutoDueOrder, isPackedOrder, patientStageOf };